import {
  Box,
  Button,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Checkbox,
  FormControlLabel,
  TextField,
  InputAdornment,
  Select,
  MenuItem,
  ClickAwayListener,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { useEffect, useState, useRef } from "react";
import { ReactComponent as AddIcon } from "../../Assets/Icons/AddIcon.svg";
import { connect } from "react-redux";
import {
  START_GET_IMPORT_CSV_LIST,
  START_DELETE_MULTIPLE_AND_SINGLE_CSV,
  RESET_PATIENT_STATE,
  START_GET_IMPORT_PATIENT_DUPLICATE,
  START_IMPORT_PATIENT_DUPLICATE_DELETE,
} from "../../Actions/PatientAction";
import { useIntersection } from "../../Hooks/customHooks";
import _ from "underscore";
import moment from "moment";
import { getClearObject } from "../../utils/generalUtils";
import { ReactComponent as EditIcon } from "Assets/Icons/EditIcon.svg";
import { ReactComponent as DeleteIcon } from "Assets/Icons/DeleteIcon.svg";
import { ReactComponent as DeleteIconBold } from "../../Assets/Icons/PharmsmartIcon/DeleteIcon.svg";
import "../../Sass/Common.scss";
import HtmlTooltipMain from "../../Components/Common/HtmlTooltipMain";
import TableEmptyState from "../../Components/Common/Table/TableEmptyState";
import TableLoadMore from "../../Components/Common/Table/TableLoadMore";
import TableCellLoader from "../../Components/Common/Table/TableCellLoader";
import PrimaryIcon from "../../Components/Common/PrimaryIcon";
import { ReactComponent as SearchIcon } from "../../Assets/Icons/SearchIcon.svg";
import { ReactComponent as Info } from "../../Assets/Icons/info.svg";
import clsx from "clsx";
import useViewport from "../../Hooks/useViewport";
import { useSelector } from "react-redux";
import SubscriptionWaringDailog from "../../Components/Common/Dialog/SubscriptionWaringDailog";
import { BorderColor, BorderStyle, Margin } from "@mui/icons-material";
import PatientCreateDialog from "../../Components/ImportCsv/PatientCreateDialog";
import ImportExtraDataDiloag from "../../Components/ImportCsv/ImportExtraDataDiloag";
import ImportCsvPatientDialog from "../../Components/ImportCsv/ImportCsvPatientDialog";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useNavigate } from "react-router-dom";

const ConfirmationDialog = React.lazy(() =>
  import("../../Components/Common/Dialog/ConfirmationDialog")
);
const useStyle = makeStyles((theme) => ({
  rsPatientHeader: {
    display: "flex",
    justifyContent: "end",
    "&>button": {
      height: "37px !important",
      marginLeft: "10px",
      [theme.breakpoints.down("906")]: {
        marginTop: "10px",
        marginLeft: "10px",
        marginRight: "10px",
      },
    },
    "&>div": {
      height: "37px !important",
      width: "200px",
      marginTop: "-1px",
      [theme.breakpoints.down("896")]: {
        marginTop: "10px",
        marginLeft: "10px",
      },
    },
  },
  iconBtn: {
    marginTop: "3px !important",
    borderRadius: "10% !important",
  },
  tableBody: {
    "&>tr": {
      "&>td": {},
    },
  },
  rsPatientFCount: {
    backgroundColor: " #333",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "6px 10px",

    // marginBottom: "20px",
    // display: "flex",
    // justifyContent: "end",
    "&>button": {
      marginLeft: "20px",
    },
  },
  iconBtn: {
    marginTop: "0px !important",
    borderRadius: "10% !important",
  },
  managePageH: {
    "& .MuiTableContainer-root": {
      maxHeight: "calc(99vh - 200px) !important",
      // padding: "13px !important",
      [theme.breakpoints.down(1400)]: {
        maxHeight: "calc(96vh - 200px) !important",
      },
      "&>table": {
        "&>thead": {
          "&>tr": {
            "&>th": {
              "&:first-child": {
                whiteSpace: "nowrap",
              },
              " &:nth-child(2)": {
                whiteSpace: "nowrap",
              },
              " &:nth-child(3)": {
                whiteSpace: "nowrap",
              },
              " &:nth-child(4)": {
                whiteSpace: "nowrap",
              },
              " &:nth-child(5)": {
                whiteSpace: "nowrap",
              },
            },
          },
        },
        "&>tbody": {
          "&>tr": {
            "&>td": {
              "&:first-child": {
                whiteSpace: "nowrap",
              },
              " &:nth-child(2)": {
                whiteSpace: "nowrap",
              },
              " &:nth-child(3)": {
                whiteSpace: "nowrap",
              },
              " &:nth-child(4)": {
                whiteSpace: "nowrap",
              },
              " &:nth-child(5)": {
                whiteSpace: "nowrap",
              },
            },
          },
        },
      },
    },
  },
  managePageHMob: {
    "& .MuiTableContainer-root": {
      // padding: "13px !important",
      [theme.breakpoints.down("1200")]: {
        maxHeight: " !important",
      },
      "&>table": {
        "&>thead": {
          "&>tr": {
            "&>th": {
              "&:first-child": {
                whiteSpace: "nowrap",
              },
              " &:nth-child(2)": {
                whiteSpace: "nowrap",
              },
              " &:nth-child(3)": {
                whiteSpace: "nowrap",
              },
              " &:nth-child(4)": {
                whiteSpace: "nowrap",
              },
              " &:nth-child(5)": {
                whiteSpace: "nowrap",
              },
            },
          },
        },
        "&>tbody": {
          "&>tr": {
            "&>td": {
              "&:first-child": {
                whiteSpace: "nowrap",
              },
              " &:nth-child(2)": {
                whiteSpace: "nowrap",
              },
              " &:nth-child(3)": {
                whiteSpace: "nowrap",
              },
              " &:nth-child(4)": {
                whiteSpace: "nowrap",
              },
              " &:nth-child(5)": {
                whiteSpace: "nowrap",
              },
            },
          },
        },
      },
    },
  },
  rsSelectMenulist: {
    position: "absolute !important",
    marginLeft: "-154px !important",
    width: "150px !important",
    opacity: "0 !important",
  },
  MenuListDownload: {
    borderColor: "#7BC044 !important",
    borderStyle: "solid !important",
    backgroundColor: "rgba(234, 251, 227, 1) !important",
    borderWidth: "2px !important",
    margin: "5px 20px !important",
    textAlign: "center !important",
    justifyContent: "center !important",
  },
  textSearch: {
    cursor: "default !important",
    width: "40px !important",
    marginTop: "-10px !important",
    marginBottom: "10px !important",
    "&>div": {
      "&>div": {
        paddingRight: "3px !important",
        "&>div": {
          marginLeft: "-18px",
        },
      },
      "&>input": {
        padding: "0px",
      },
    },
  },
  isExpandSearch: {
    cursor: "default !important",
    width: "200px !important",
    marginTop: "-10px !important",
    marginBottom: "10px !important",
    "&>div": {
      "&>div": {
        "&>div": {
          marginRight: "-4px !important",
        },
      },
    },
  },
  buttonbackIcon: {
    backgroundColor: "#7bbd4b !important",
    height: "40px",
    width: "40px",
    borderRadius: "5px !important",
    display: "flex",
    alignItems: "center",
    "&>svg": {
      fill: "white",
      marginLeft: "10px",
    },
  },
  rsButtonAddIcon: {
    background: "#e9514e !important",
    padding: "12px !important",
    borderRadius: "5px !important",
    "&>svg": {
      "&>path": {
        fill: "#e9514e !important",
        stroke: "white",
      },
    },
    "&:disabled": {
      background: "rgba(90, 104, 114,1) !important",
      "&>svg": {
        "&>path": {
          fill: "rgba(90, 104, 114,1) !important",
          stroke: "white",
        },
      },
    },
  },
}));

const ImportDuplicateMain = (props) => {
  const {
    getImportDuplicateListAction,
    importduplicatePatient,
    deleteDuplicatePatientAction,
    deleteDuplicatePatientData,
    resetPatientState,
  } = props;
  const classes = useStyle();
  const [setTarget, entry] = useIntersection({ threshold: 0.1 });
  const patientListRecordLimit = 20;
  const [openCreatePatientPopup, setOpenCreatePatientPopup] = useState(false);
  const [createNewPatientFromCSV, setCreateNewPatientFromCSV] = useState("");
  const [deleteCsvData, setDeleteCsvData] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [selected, setSelected] = React.useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [extraDataDiloag, setExtraDataDiloag] = useState(false);
  const [extraData, setExtraData] = useState([]);
  const [subscriptionDialog, setSubscriptionDialog] = useState(false);
  const width = useViewport();
  const { loginUserDetail } = useSelector((state) => state.user);
  const [deleteRecordActionType, setDeleteRecordActionType] =
    React.useState("");
  const [openImportCsvPopup, setOpenImportCsvPopup] = useState(false);
  const [expand, setExpand] = useState(true);
  const textFieldRef = useRef(null);
  const navigate = useNavigate();
  /** Get patient api main function */
  const getList = (params = {}) => {
    let payload = {
      offset: 0,
      q: searchValue,
      limit: patientListRecordLimit,
    };
    payload = {
      ...payload,
      ...params,
    };
    getImportDuplicateListAction(getClearObject(payload));
  };

  const handleDeleteCsvList = () => {
    let payload = {
      id:
        deleteRecordActionType === "singleRecordDelete" ? [deleteId] : selected,
      is_delete_all:
        selected?.length === importduplicatePatient?.data?.list?.length,
    };
    deleteDuplicatePatientAction(payload);
  };
  useEffect(() => {
    getList();
  }, []);
  const onSuccessOfSubmitPatientForm = () => {
    setOpenImportCsvPopup(false);
    getList();
  };
  /** Pagination useEffect */
  useEffect(() => {
    if (entry.isIntersecting) {
      if (
        importduplicatePatient?.data?.list?.length !=
        importduplicatePatient?.data?.filterd_record
      ) {
        getList({
          offset: importduplicatePatient?.data?.list?.length,
          limit: patientListRecordLimit,
        });
      }
    }
  }, [entry]);

  /** Delete Patient loading useEffect */
  useEffect(() => {
    if (
      !deleteDuplicatePatientData?.loading &&
      Object.keys(deleteDuplicatePatientData?.data)?.length
    ) {
      setDeleteCsvData(false);
      setDeleteId("");
      resetPatientState("deleteMultipleAndSingleCsvData", "");
      setSelected([]);
    }
  }, [deleteDuplicatePatientData]);

  /* Handle Change Action */
  const handleChangeAction = (e) => {
    if (e.target.checked) {
      const newSelected = importduplicatePatient?.data?.list?.map(
        (item) => item?.dpi_id
      );
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  /* Handle Click Tick Action */
  const handleClickTickAction = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };

  /** Search debounce useref */
  const searchUserDebounce = useRef(
    _.debounce((searchString, otherStateValues = {}) => {
      getList({
        ...(searchString && {
          q: searchString,
        }),
        ...otherStateValues,
      });
    }, 500)
  );
  /** Handle Search Funcation */
  const handleSearch = (newValue) => {
    let payLoad = {};
    searchUserDebounce.current(newValue, {});
  };
  const handleClickAway = () => {
    if (searchValue == "") {
      setExpand(false);
    }
  };
  return (
    <>
      <Grid>
        <Grid className={classes.rsPatientFCount}>
          <Box>
            <HtmlTooltipMain
              title="Back to Patients List"
              className="hoverAlign"
            >
              <IconButton
                className={classes.buttonbackIcon}
                onClick={() => {
                  navigate("/patients");
                }}
              >
                {/* <HtmlTooltipMain
                            title="Back to Patients List"
                            className="hoverAlign"
                          > */}
                <ArrowBackIosIcon />
                {/* <HtmlTooltipMain/> */}
              </IconButton>
            </HtmlTooltipMain>
          </Box>
          <Grid className={classes.rsPatientHeader}>
            <Box
              className={expand ? classes.isExpandSearch : classes.textSearch}
            >
              {/* <ClickAwayListener onClickAway={handleClickAway}> */}
              <TextField
                inputRef={textFieldRef}
                withPadding={true}
                medium
                secondary
                placeholder="Search..."
                value={searchValue}
                onChange={(e) => {
                  setSearchValue(e?.target?.value);
                  handleSearch(e?.target?.value);
                }}
                onClick={() => {
                  if (textFieldRef.current) {
                    textFieldRef.current.focus();
                  }
                  setExpand(true);
                }}
                InputProps={{
                  endAdornment: (
                    <>
                      <InputAdornment
                        position="start"
                        onClick={() => {
                          if (textFieldRef.current) {
                            textFieldRef.current.focus();
                          }
                          setExpand(true);
                        }}
                      >
                        <PrimaryIcon
                          width="20px"
                          icon={SearchIcon}
                          onClick={() => {
                            if (textFieldRef.current) {
                              textFieldRef.current.focus();
                            }
                            setExpand(true);
                          }}
                        />
                      </InputAdornment>
                    </>
                  ),
                }}
              />
              {/* </ClickAwayListener> */}
            </Box>
            {selected?.length > 0 && (
              <HtmlTooltipMain title="Delete " className="hoverAlign">
                <IconButton
                  className={classes.rsButtonAddIcon}
                  variant="contained"
                  disabled={
                    selected?.length === 0 ||
                    importduplicatePatient?.data?.list?.length === 0
                  }
                  onClick={() => {
                    setDeleteRecordActionType("multipleRecordDelete");
                    setSelected([...selected]);
                    setDeleteCsvData(true);
                  }}
                >
                  <PrimaryIcon
                    width="20px"
                    icon={DeleteIconBold}
                    cursor="pointer"
                  />
                </IconButton>
              </HtmlTooltipMain>
              // <Button
              //   className={clsx("BtnGreen", classes.rsButtonAddIcon)}
              //   variant="contained"
              //   onClick={() => {
              //     setDeleteRecordActionType("multipleRecordDelete");
              //     setSelected([...selected]);
              //     setDeleteCsvData(true);
              //   }}
              //   disabled={
              //     selected?.length === 0 ||
              //     importduplicatePatient?.data?.list?.length === 0
              //   }
              // >
              //   Delete
              // </Button>
            )}
          </Grid>
        </Grid>
        <Grid
          className={clsx(
            "common-table",
            width <= 1200 ? classes.managePageHMob : classes.managePageH
          )}
        >
          <TableContainer>
            <Table stickyHeader>
              <TableHead className={classes.tableHead}>
                <TableRow>
                  <TableCell>
                    <Box>
                      {importduplicatePatient?.data?.list?.length > 0 && (
                        <FormControlLabel
                          className={classes.labelWhiteSpaceNW}
                          checked={
                            importduplicatePatient?.data?.list?.length > 0 &&
                            selected?.length ===
                              importduplicatePatient?.data?.list?.length
                          }
                          onChange={handleChangeAction}
                          control={<Checkbox color="primary" />}
                        />
                      )}
                      FIRST NAME
                    </Box>
                  </TableCell>
                  <TableCell>LAST NAME</TableCell>
                  <TableCell>DOB</TableCell>
                  <TableCell>EXTRA DATA</TableCell>
                  {/* <TableCell>ACTION</TableCell> */}
                </TableRow>
              </TableHead>
              <TableBody className={classes.tableBody}>
                {importduplicatePatient?.loading ? (
                  <TableCellLoader cells={4} />
                ) : importduplicatePatient?.data?.list?.length > 0 ? (
                  importduplicatePatient?.data?.list?.map((item, i) => {
                    const isSelected = (id) => selected?.indexOf(id) !== -1;
                    const isItemSelected = isSelected(item?.dpi_id);
                    const labelId = `enhanced-table-checkbox-${i}`;
                    return (
                      <TableRow key={item?.dpi_id}>
                        <TableCell
                          semiBold
                          onClick={(event) =>
                            handleClickTickAction(event, item?.dpi_id)
                          }
                        >
                          <Box>
                            <FormControlLabel
                              className={classes.labelWhiteSpaceNW}
                              checked={isItemSelected}
                              control={<Checkbox color="primary" />}
                              label=""
                              inputProps={{
                                "aria-labelledby": labelId,
                              }}
                            />
                            {item?.dpi_other_detail?.first_name}
                          </Box>
                        </TableCell>
                        <TableCell semiBold>
                          {item?.dpi_other_detail?.last_name
                            ? item?.dpi_other_detail?.last_name
                            : "-"}
                        </TableCell>
                        <TableCell>
                          {item?.dpi_other_detail?.dob
                            ? moment(
                                new Date(item?.dpi_other_detail?.dob)
                              ).format("DD-MM-YYYY")
                            : "-"}
                        </TableCell>
                        <TableCell>
                          <HtmlTooltipMain
                            title="Extra data"
                            className="hoverAlign"
                          >
                            <IconButton
                              onClick={() => {
                                setExtraDataDiloag(true);
                                setExtraData(item?.dpi_extra_data);
                              }}
                            >
                              <PrimaryIcon
                                color="primary"
                                width="20px"
                                icon={Info}
                                cursor="pointer"
                              />
                            </IconButton>
                          </HtmlTooltipMain>
                        </TableCell>
                        {/* <TableCell>
                          <Box
                            display={"flex"}
                            fontWeight="300"
                            alignItems={"center"}
                          >
                            <HtmlTooltipMain
                              title="Create Patient"
                              className="hoverAlign"
                            >
                              <IconButton
                                onClick={() => {
                                  setOpenCreatePatientPopup(true);
                                  setCreateNewPatientFromCSV(item);
                                }}
                              >
                                <PrimaryIcon
                                  color="primary"
                                  width="20px"
                                  icon={EditIcon}
                                  cursor="pointer"
                                />
                              </IconButton>
                            </HtmlTooltipMain>
                            <HtmlTooltipMain
                              title="Delete"
                              className="hoverAlign"
                            >
                              <IconButton
                                onClick={() => {
                                  setDeleteRecordActionType(
                                    "singleRecordDelete"
                                  );
                                  setDeleteId(item?.dpi_id);
                                  setDeleteCsvData(true);
                                }}
                              >
                                <PrimaryIcon
                                  width="20px"
                                  icon={DeleteIcon}
                                  cursor="pointer"
                                />
                              </IconButton>
                            </HtmlTooltipMain>
                          </Box>
                        </TableCell> */}
                      </TableRow>
                    );
                  })
                ) : (
                  <TableEmptyState />
                )}
                {importduplicatePatient?.data?.list?.length !=
                  importduplicatePatient?.data?.filterd_record && (
                  <TableLoadMore setRef={setTarget} />
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
      <ImportExtraDataDiloag
        open={extraDataDiloag}
        setOpen={setExtraDataDiloag}
        extraData={extraData}
      />
      <ImportCsvPatientDialog
        open={openImportCsvPopup}
        setOpen={setOpenImportCsvPopup}
        getImportDuplicateListAction={getImportDuplicateListAction}
        subscriptionDialog={subscriptionDialog}
        setSubscriptionDialog={setSubscriptionDialog}
        loginUserDetail={loginUserDetail}
      />
      <ConfirmationDialog
        open={deleteCsvData}
        setOpen={setDeleteCsvData}
        title="Are you sure?"
        body="You wan't be able to undo this!"
        handleSubmit={handleDeleteCsvList}
        actionBtnTitle="Yes Delete It!!"
        loading={deleteDuplicatePatientData?.loading}
      />
      <PatientCreateDialog
        open={openCreatePatientPopup}
        setOpen={setOpenCreatePatientPopup}
        callBackOnSubmit={onSuccessOfSubmitPatientForm}
        createNewPatientFromCSV={createNewPatientFromCSV}
      />
      <SubscriptionWaringDailog
        open={subscriptionDialog}
        setOpen={setSubscriptionDialog}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  importduplicatePatient: state.patient.importduplicatePatient,
  deleteDuplicatePatientData: state.patient.deleteDuplicatePatientData,
});

const mapDispatchToProps = (dispatch) => ({
  getImportDuplicateListAction: (payload) =>
    dispatch({ type: START_GET_IMPORT_PATIENT_DUPLICATE, payload }),
  deleteDuplicatePatientAction: (payload) =>
    dispatch({ type: START_IMPORT_PATIENT_DUPLICATE_DELETE, payload }),
  resetPatientState: (key, payload) =>
    dispatch({ type: RESET_PATIENT_STATE, key, payload }),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ImportDuplicateMain);
